WS_CONNECTION_REFUSED_CODE = 1006
WS_DISCONNECT_SUCCESS_CODE = 1005

SipService = Em.Service.extend Em.Evented,
  session: Em.inject.service()
  env:     Em.inject.service('environment')

  _getPhoneNumber: (uri) ->
    match = uri.match /.*?<(.*?)@.*?/
    return match[1].replace(/^(sip:|tel:)/, '').replace(/^([\d]{10})$/,'7$&') if match

  reloadFlag: true

  sipEnabled:  false
  sipLogin:    null
  sipPassword: null

  userAgent: null
  sipState: 'offline'
  sipError: null

  init: ->
    @_super(arguments...)

    @on 'settingsUpdated', =>
      Em.Logger.log '[SIP] Получили сигнал обновления настроек'
      @notifyPropertyChange('reloadFlag')

  # ---
  # При смене пользователя или настроек переинициализировать
  # ---
  onCurrentUserChanged: (->
    @sipSessionTeardown()
    .catch =>
      false
    .finally =>
      @sipSessionInit()
        .catch =>
          console.error 'sipSessionInitError', arguments
          false
  ).observes(
    'reloadFlag',
    'session.currentUser').on('init')

  # ---
  # Погасить текущую сессию
  # ---
  sipSessionTeardown: ->
    new Em.RSVP.Promise (resolve, reject) =>
      userAgent = @get('userAgent')
      return resolve() unless userAgent

      Em.Logger.log '[SIP] Отключаюсь от сипа...'
      @set('sipState', 'disconnecting')
      userAgent.stop()
      userAgent.on 'disconnected', =>
        @set('userAgent', null)
        resolve()

  # ---
  # Начать новую сессию
  # ---
  sipSessionInit: ->
    new Em.RSVP.Promise (resolve, reject) =>
      user = @get('session.currentUser')

      if not user
        return reject('No user present')

      @set('sipEnabled',  user._data['sip_enabled'])
      @set('sipLogin',    user._data['sip_login'])
      @set('sipPassword', user._data['sip_password'])

      if not @get('sipEnabled')
        Em.Logger.log "[SIP] Выключен для данного пользователя"
        return reject('Disabled for current user')

      login    = @get('sipLogin')
      password = @get('sipPassword')
      wsUrl    = @get('env').get('sipWSUrl')

      if [login, password, wsUrl].any(Em.isEmpty)
        Em.Logger.log "[SIP] Нет настроек для данного пользователя (#{login}, #{password}, #{wsUrl})"
        return reject('Empty sip credentials')

      socket = new JsSIP.WebSocketInterface(wsUrl)
      uaConfig =
        sockets           : [ socket ]
        uri               : login
        password          : password

      try
        userAgent = new JsSIP.UA(uaConfig)
      catch e
        Em.Logger.log '[SIP] Ошибка инициализации UA', e
        @set('sipState', 'error')
        @set('sipError', 'init_failed')
        return reject('Sip init failed')

      @set('userAgent', userAgent)
      @set('sipError', null)
      @set('sipState', 'connecting')

      Em.Logger.log "[SIP] Подключаюсь к #{wsUrl}"

      userAgent.on 'connected', (e) =>
        Em.Logger.log('[SIP] Подключилcя')

      userAgent.on 'disconnected', (e) =>
        Em.Logger.log('[SIP] Отключился', e)

        if e.code isnt WS_DISCONNECT_SUCCESS_CODE
          @set('sipState', 'error')
          @set('sipError', 'connection_failed')
        else
          @set('sipState', 'offline')

        reject('Connection failed')

      userAgent.on 'registrationFailed', (e) =>
        Em.Logger.log('[SIP] Ошибка регистрации', e)
        @set('sipState', 'error')
        @set('sipError', 'registration_failed')
        reject('Registration failed')

      userAgent.on 'registered', (e) =>
        Em.Logger.log('[SIP] Зарегистрировался')
        @set('sipState', 'online')
        resolve()

      userAgent.on 'newRTCSession', (e) =>
        Em.Logger.log("[SIP] Входящий звонок")
        phone_number = @_getPhoneNumber(e.request.getHeader('From'))
        @trigger('call', phone_number)

      userAgent.start()

module.exports = SipService
